import React from 'react'
import { bool, string, object, func, any } from 'prop-types'
import Overlay from './components/Overlay'

const Dialog = ({
  closeDialog = () => {},
  hasBackdrop = false,
  children,
  shouldRender = true,
  activeView = '',
  className = '',
  style = {}
}) => {
  return shouldRender ? (
    <div className={`dialog ${className}`} {...{ style }}>
      <Overlay shouldRender={hasBackdrop} {...{ closeDialog }} />
      <div className="content">{children}</div>
    </div>
  ) : null
}

Dialog.propTypes = {
  activeView: string,
  children: any,
  className: string,
  closeDialog: func,
  hasBackdrop: bool,
  shouldRender: bool,
  style: object
}

export default Dialog
